import { useRef, useEffect, useMemo } from 'react';
import QRCode, { QRCodeRenderersOptions } from 'qrcode';

interface IQRCode {
  text: string;
  options: QRCodeRenderersOptions;
}

export const useQRCode = () => {
  const CanvasComponent = <T extends HTMLCanvasElement>({ text, options }: IQRCode) => {
    const canvasRef = useRef<T>(null);

    useEffect(() => {
      if (canvasRef && canvasRef.current && text) {
        QRCode.toCanvas(canvasRef.current, text, options, () => {});
      }
    }, [canvasRef, text, options]);

    return <canvas ref={canvasRef} />;
  };

  const Canvas = useMemo(() => CanvasComponent, []);

  return Canvas;
};
